import EventBus from "../EventBus";

export default {
  props : ['services'],
  watch : {
  },
  name: 'price-modal',
  data : () => ({
    // services: [],
    _toggle: false,
  }),
  computed: {
  },
  methods: {
    // services : services
  },
  created() {
    this._toggle = false
    console.log('[Console] Billing Price', 'created');
  },
  destroyed() {EventBus.$off('services1'); console.log('[Console] Billing Price', 'destroyed'); },
  mounted() {
    // EventBus.$on('services1', (a) => {
    //   console.info(a, "AAA")
    //   this.services = a
    // })
    // this.services = this.$parent.$attrs.services;
    // console.log('X - Price', this)
    console.log('[Console] Billing Price', 'mounted'); },
}
